module.exports = __webpack_public_path__ + "img/recruit_cont06_img03.6d2ef4ff.png";